/**
 *Round off reason code to store variance less than one rupee.
 */
export const ROUND_OFF_SHORT  = "ROUND_OFF_SHORT";
export const ROUND_OFF_EXCESS = "ROUND_OFF_EXCESS";

/**
 * List of all possible excess variances reason from the station side
 */
export const EXCESS_VARIANCE_REASON = [
    {
        reasonCode: "RECOVERY_PREVIOUS_SHORT_CASH",
        requireIssueLink: false,
        reasonLabel: "Recovery previous short cash",
    },
    {
        reasonCode: "ACCUMULATED_COINS",
        requireIssueLink: false,
        reasonLabel: "Accumulated coins",
    },
    {
        reasonCode: "CASH_DUE_TO_DA_ID_NOT_VISIBLE",
        requireIssueLink: true,
        reasonLabel: "Cash due to DA ID not visible",
    },
    {
        reasonCode: ROUND_OFF_EXCESS,
        requireIssueLink: false,
        reasonLabel: "Round off excess"
    }
];

/**
 * List of all possible short variances reason from the station side
 */
export const STATION_SHORT_VARIANCE_REASON = [
    {
        reasonCode: "CASH_NOT_AT_STATION",
        requireIssueLink: true,
        reasonLabel: "Cash not at station",
    },
    {
        reasonCode: ROUND_OFF_SHORT,
        requireIssueLink: false,
        reasonLabel: "Round off short"
    }
];

/**
 * List of all possible short variances reason from the external vendor side
 */
export const EXTERNAL_VENDOR_SHORT_REASON = [
    {
        reasonCode: "SOILED_NOTES",
        requireIssueLink: false,
        reasonLabel: "Soiled notes",
    },
    {
        reasonCode: "SUSPECT_NOTES",
        requireIssueLink: false,
        reasonLabel: "Suspect notes",
    },
    { 
        reasonCode: "COINS", 
        requireIssueLink: false, 
        reasonLabel: "Coins" 
    },
    {
        reasonCode: "BANK_DEPOSIT_LIMIT_REACHED",
        requireIssueLink: false,
        reasonLabel: "Bank deposit limit reached",
    },
];

export const RemittanceStatus = {
    CREATED: "CREATED",
    PENDING_SUBMISSION: "PENDING_SUBMISSION",
    SUBMITTED: "SUBMITTED",
};

/**
 * Default reason code for short variance by the station
 */
export const DEFAULT_STATION_SHORT_CODE = "DEFAULT_STATION_SHORT";

export const VarianceType = {
    SHORT: "SHORT",
    EXCESS: "EXCESS",
};

export const VarianceReasonFormat = {
    CLIENT: 0,
    REASON_CODE: 1,
    ISSUE_LINK: 2
};

export const ExcelVarianceReasonFormat = {
    REASON_CODE: 0,
    ISSUE_LINK: 1
}

export const VarianceClients = {
    BOSON: "BOSON",
    EXTERNAL_VENDOR: "EXTERNAL_VENDOR",
};

export const ErrorCodes = {
    INVALID_REMITTANCE_CODE: "INVALID_REMITTANCE_CODE"
}

export const ONLY_ISSUE_LINK_REGEX = "^((http(s)?):\\/\\/)(tt|t\\.corp|issues|sim)\\.amazon.com[a-zA-Z0-9-\\/]+$";



// WEBPACK FOOTER //
// ./src/component/common/remittanceV2Constants.js